import { useMutation, useQueryClient } from '@tanstack/react-query'

import { putRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { MarkNotificationAsReadResponse } from 'src/shared/schemas/stream/notification'

const markNotificationAsRead = async (notificationId: string) => {
  try {
    const response = await putRequest<MarkNotificationAsReadResponse>(
      `/feeds/notifications/mark-as-read?notification_id=${notificationId}`,
    )
    if (!response) {
      throw new Error('Failed to mark notification as read')
    }
    return response
  } catch (error) {
    throw new Error(`Failed to mark notification as read | ${error}`)
  }
}

export const useMarkNotificationAsRead = () => {
  const queryClient = useQueryClient()

  return useMutation({
    ...queries.notifications.markAsRead,
    mutationFn: markNotificationAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queries.notifications._def })
    },
  })
}
